<template>
  <div class="SX">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoPartyDiscipline">党纪法规></span>
        <span @click="GoFenLei">分类系统></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
      <div class="zhengwen">
        <h1>中共中央纪委法规室对《关于村委会主任（党员）利用职务之便收受财物行为如何处理的请示》的答复</h1>
        <div class="first">
          <p></p>
        </div>
        <div class="date">发布时间：2020-5-20&nbsp13:30</div>
        <div class="xh"></div>

        <div class="second">
          <P>
            中共安徽省纪委：
            你们送来的《关于村委会主任（党员）利用职务之便收受财物行为如何处理的请示》（皖纪〔2005〕37号）以及你委法规室补充送来的《关于村委会主任等人利用职务之便收受财物行为如何处理的请示的补充材料》收悉。经研究，现答复如下：
          </P>
          <strong>
            <p>一、关于能否按照《中国共产党纪律处分条例》第九十五条定性处理的问题</p>
          </strong>
          <p>根据现有材料，我们认为，对本案中张某、王某的行为不能按照《中国共产党纪律处分条例》（以下简称《党纪处分条例》）第九十五条的规定定性处理。</p>

          <p>根据《中华人民共和国村民委员会组织法》等法律规定，你省该村支委会和村委会研究决定，将出售属于村林场木材所得款项30万元用于维修村级公路（未报乡政府审批）的活动，是村民自治范围内的经营、管理活动，不属于《党纪处分条例》第九十五条所列协助人民政府从事行政管理工作和依照党内法规从事党的纪检、组织（人事）、宣传等公务活动。因此，对该村委会主任张某及村委会委员王某在修路过程中收受修路包工头现金的行为，不能按照《党纪处分条例》第九十五条的规定定性处理。</p>

          <p>二、关于能否按照《党纪处分条例》第一百零一条定性处理的问题</p>

          <p>根据现有材料，我们认为，对本案中张某、王某的行为，应当按照《党纪处分条例》第一百零一条的规定定性处理。</p>

          <p>《党纪处分条例》第一百零一条第一款规定：“企业（公司）或者其他单位中的非国家工作人员，利用职务上的便利，索取他人财物，或者非法收受、变相非法收受他人财物为他人谋取利益，情节较轻的，给予警告或者严重警告处分；情节较重的，给予撤销党内职务或者留党察看处分；情节严重的，给予开除党籍处分。＂</p>

          <p>本案中村委会主任张某及村委会委员王某的行为，在行为的主体、主观方面、客观方面、侵害的客体四个方面都符合《党纪处分条例》第一百零一条第一款的构成要件：张某、王某属于其他单位中的非国家工作人员；主观上具有收受他人财物的故意；客观上具有利用职务上的便利，非法收受县路桥公司负责人陈某现金为陈某谋取利益的行为；同时侵害了国家对有关单位的正常管理秩序。因此，对本案中张某、王某的行为，应当按照《党纪处分条例》第一百零一条的规定定性处理。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    GoPartyDiscipline() {
      this.$router.push("/PartyDiscipline");
    },
    GoFenLei() {
      this.$router.push("/PartyDiscipline/FenLei");
    }
  }
};
</script>
<style lang="less" scoped>
.date {
  color: #999999;
  font-size: 16px;
  text-align: center;
  margin-bottom: 28px;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}

h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.first p {
  font-weight: 600;
}
</style>